import axios from 'smg/axios';
import * as hyejoo from 'smg/customer-api/hyejoo';
import * as paymentmethods from 'smg/customer-api/paymentoptions';
import * as session from 'smg/customer-api/session';
import * as models from 'smg/models';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import { UUID } from 'smg/uuid';
import { PageLoader } from '../account';
import { Relref } from '../hugo';
import { DrawPaymentOption, PromptNewPaymentOption } from '../payments';

export default async function main() {
    if (await session.Redirect(undefined, Relref('/login'))) {
        return;
    }

    const sess = await session.Session();

    const cardTemplate = document.querySelector('#card') as HTMLTemplateElement;
    const parent = document.querySelector('#paymentMethodsContainer') as HTMLElement;
    const addNewTemplate = document.querySelector('#addNewTemplate') as HTMLElement;
    const addNewButton = document.querySelectorAll('.addNew');

    addNewButton.forEach(el => {
        el.addEventListener('click', () => {
            void PromptNewPaymentOption(sess, 'Save', [models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_BANK, models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT]).then(() => {
                pl.Load();
            });
        });
    });

    const pl: PageLoader<models.PaymentOption> = new PageLoader<models.PaymentOption>({
        afterLoad: () => {
            parent.append(addNewTemplate);
            addNewTemplate.classList.remove('d-none');
        },
        parent: document.querySelector('#paymentMethodsContainer') as HTMLElement,
        get: () => axios.get<hyejoo.PaymentOptions>('/payment-options', {
            params: {
                'sort': pl.Sort(),
                'max': pl.CurrentPageSize(),
                // 'data': 'id, userTaxExemptionReasonID, countryID, stateID, number, UserTaxExemptionReason, userTaxExemptionUploads, created',
                'p': pl.CurrentPage(),
                'q': pl.Search() + 'has:email has:phone has:fullName has:addressLine1 has:city has:countryID has:zip valid:yes',
            },
        }).then(resp => ({ rows: resp.data.paymentOptions, nextPage: resp.data.nextPage })),
        draw: async resp => {
            const card = template.Clone(cardTemplate);
            const deleteBtn = card.querySelector<HTMLButtonElement>('.delete-btn');
            const editBtn = card.querySelector<HTMLButtonElement>('.edit-btn');

            await DrawPaymentOption(resp, resp, card);

            editBtn?.addEventListener('click', () => {
                void PromptNewPaymentOption(sess, 'Update', [models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT, models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_BANK], resp).then(newPayment => {
                    resp = newPayment;
                    pl.Load();
                });
            });

            deleteBtn?.addEventListener('click', () => {
                void paymentmethods.DeletePaymentOption(resp.id || '').
                    then(() => {
                        card.parentElement?.removeChild(card);
                        const undoLinkID = `undo-${UUID()}`;
                        const t = toast.Success(`Removed payment method. <a href="#" class="text-white text-decoration-underline" id="${undoLinkID}">Undo</a>`);
                        const undo = document.querySelector(`#${undoLinkID}`) as HTMLAnchorElement;
                        undo.addEventListener('click', async e => {
                            e.preventDefault();
                            t?.dispose();
                            await paymentmethods.RestorePaymentOption(resp.id || '');
                            pl.Load();
                        });
                        pl.Load();
                    });
            });

            return card;
        },

    });

    parent?.previousElementSibling?.classList.add('d-none');

    pl.Load();
}